import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, Grid, TableRow } from '@mui/material';
import TaskListItemComponent from './TaskListItemComponent';
import { TableCellTaskItem } from './TaskStyles';
import { BoldTableHead } from 'components/common/CommonStyles';

const TaskListComponent = ({ tasks, onOpenOffer, onAssignToMe, onStartTask, onPauseTask, onOpenModal, onTogglePriority, userInfo }) => {
  const { t } = useTranslation();

  return (
    <Grid container mt={2}>
      <Grid item xs={12}>
        <Table>
          <BoldTableHead>
            <TableRow>
              <TableCellTaskItem>{t('TaskList.Name')}</TableCellTaskItem>
              <TableCellTaskItem>{t('TaskList.State')}</TableCellTaskItem>
              <TableCellTaskItem>{t('TaskList.Description')}</TableCellTaskItem>
              <TableCellTaskItem>{t('TaskList.Age')}</TableCellTaskItem>
              <TableCellTaskItem>{t('TaskList.Responsible')}</TableCellTaskItem>
              <TableCellTaskItem></TableCellTaskItem>
            </TableRow>
          </BoldTableHead>
          <TableBody>
            {tasks.map((task, index) => {
              return (
                <TaskListItemComponent
                  task={task}
                  key={index}
                  internalOnOpenOffer={onOpenOffer(task)}
                  onAssignToMe={onAssignToMe}
                  onPauseTask={onPauseTask}
                  onStartTask={onStartTask}
                  onOpenModal={onOpenModal}
                  onTogglePriority={onTogglePriority}
                  userInfo={userInfo}
                />
              );
            })}
          </TableBody>
        </Table>
      </Grid>
    </Grid>
  );
};

TaskListComponent.propTypes = {
  tasks: PropTypes.array.isRequired,
  onOpenOffer: PropTypes.func.isRequired,
  onAssignToMe: PropTypes.func.isRequired,
  onStartTask: PropTypes.func.isRequired,
  onPauseTask: PropTypes.func.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  onTogglePriority: PropTypes.func.isRequired,
  userInfo: PropTypes.object.isRequired
};

export default TaskListComponent;
